import * as React from 'react'

import { cn } from '@/lib/utils'
import { Separator } from '~/client/src/shared/components/shadcn-ui/separator'

import { SURFACE_BLEED_CLASS } from '../surfaceInset'

const OptionsSeparator: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <Separator
      className={cn(
        SURFACE_BLEED_CLASS,
        'tw:data-[orientation=horizontal]:w-auto',
        className,
      )}
    />
  )
}

export default OptionsSeparator
